import { lazy, Suspense } from 'react';
import { Loading } from '../Loading';
import type { MapViewProps } from './types';
import './map.css';

export type { MapCircle, MapLine, MapPath, MapPoint, MapViewProps } from './types';

const LeafletMap = lazy(async () => ({ default: (await import('./LeafletMap')).LeafletMap }));

/**
 * OpenStreetMap view in a panel. Leaflet (with its stylesheet) is its own chunk,
 * fetched the first time a map is shown, so pages without a map never load it.
 */
export function MapView(props: MapViewProps) {
  return (
    <Suspense
      fallback={
        <div className={props.size === 'sm' ? 'fs-map fs-map--sm' : 'fs-map'} aria-busy="true">
          <Loading />
        </div>
      }
    >
      <LeafletMap {...props} />
    </Suspense>
  );
}
